import React from 'react';

function AddFundsModal({ isOpen, onClose, walletAddress, solanaNetwork }) {
  if (!isOpen) return null;
  const handleClose = () => {
    onClose();
  };
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(walletAddress || '');
      alert('Address copied!');
    } catch (e) {
      console.error(e);
      alert('Ne udalosj skopirovatj adres');
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0,
      width: '100%', height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      zIndex: 10000
    }}>
      <div style={{
        background: '#111827',
        padding: '20px',
        borderRadius: '10px',
        color: '#fff',
        minWidth: '300px'
    }}>
      <h2>Add Funds</h2>
      <p>Send tokens to this address:</p>
      <p style={{ wordBreak: 'break-all', color: '#10b981' }}>{walletAddress || '--'}</p>
      <div style = {{ display: 'flex', gap: '10px', marginBottom: '12px' }}>
        <button
          onClick={handleCopy}
          style={{
            padding: '8px 12px',
            backgroundColor: '#facc15',
            color: '#1f2937',
            border: 'none',
            borderRadius: '8px',
            fontWeight: 600,
            cursor: 'pointer'
          }}
        >
            Copy
        </button>
      </div>

      <p>Network: {solanaNetwork}</p>

      <button
        onClick={handleClose}
        style={{ marginTop: '20px', padding: '8px 16px', backgroundColor: '#374151', borderRadius: '6px' }}
      >
        Close
      </button>
    </div>
  </div>
  );
}


export default AddFundsModal;
